import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { Skeleton } from "antd";
import PropTypes from "prop-types";

const App = lazy(() => import("./containers/App/App"));
const Signin = lazy(() => import("./containers/Auth/signin"));
const MeetingLanding = lazy(() => import("./containers/PublicPath/MeetingLanding"));
const PDFPreviewPage = lazy(() => import("./containers/Courses/PDFPreviewPage"));
const ResetPassword = lazy(() => import("./containers/Auth/resetPassword"));
const AnaBot = lazy(() => import("./containers/AnaBot"));
const DropRules = lazy(() => import("./containers/DropRules"));
const NotFound = lazy(() => import("./containers/notFound"));

const LoadingFallback = () => <Skeleton active paragraph={{ rows: 7 }} />;

const PublicRoutes = ({ isLoggedIn }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path="/"
          element={<Signin />}
        />
        <Route
          path="/signin"
          element={<Signin />}
        />
        <Route
          path="/meeting/:id"
          element={<MeetingLanding />}
        />
        <Route
          path="/dashboard/resource-preview"
          element={<PDFPreviewPage />}
        />
        <Route
          path="/reset-password/:token"
          element={<ResetPassword />}
        />
        <Route
          path="/bot"
          element={<AnaBot />}
        />
        <Route
          path="/droprules"
          element={<DropRules />}
        />
        <Route
          path="/dashboard/*"
          element={
            isLoggedIn ? <App /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </Suspense>
  );
};

PublicRoutes.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default connect((state) => ({
  isLoggedIn: !!state.Auth?.idToken,
}))(PublicRoutes);